import React from 'react';

const baseButtonClass = 'px-4 py-2 -mb-[2px] text-[13px] bg-transparent border-0 border-b-2 cursor-pointer transition-colors';
const activeButtonClass = 'font-semibold text-classic-button-normal border-classic-button-normal';
const inactiveButtonClass = 'font-normal text-main-hover border-transparent hover:text-main-normal';

const TabSwitcher = ({tabs, activeTab, onTabChange}) => (
    <div className="flex">
        {tabs.map((tab, i) => (
            <button
                key={tab.key}
                type="button"
                data-testid={`settings-tab-${tab.key}`}
                onClick={() => onTabChange(i)}
                className={`${baseButtonClass} ${activeTab === i ? activeButtonClass : inactiveButtonClass}`}
            >
                {tab.label}
            </button>
        ))}
    </div>
);

export default TabSwitcher;
